import { ProductType } from '@/types';
import { getDefaultValues } from './getDefaultValues';

export const getDefaultAppearanceId = (productType: ProductType) =>
  getDefaultValues(productType).defaultAppearance.id;
